<script setup lang="ts">
    import { computed, inject } from 'vue';
    import EventIssues from '@views/Event/EventIssues.vue';
    import { toEventRefs, getEventSegmentId } from '@views/Event/Event';
    import { type Event, type EventSegmentRelation } from '@views/Event/EventTypes';
    import { eventKey, canEditKey } from '@views/Event/EventEditor/event-editor-keys';

    defineProps<{
        eventId: string;
    }>();

    const event = inject(eventKey)!;
    const canEdit = inject(canEditKey)!;

    const eventRefs = computed(() => (event.value ? toEventRefs(event.value) : null));
    const getSegmentId = (relation: EventSegmentRelation) => getEventSegmentId(event.value, relation);
</script>

<template>
    <EventIssues v-if="eventRefs" :event="eventRefs" :getSegmentId="getSegmentId" :updateEnabled="canEdit" />
</template>

